import script from "./EditorActions.vue?vue&type=script&setup=true&lang=js"
export * from "./EditorActions.vue?vue&type=script&setup=true&lang=js"

import "./EditorActions.vue?vue&type=style&index=0&id=160f2b8c&lang=scss"

const __exports__ = script;

export default __exports__